import { AUTOCOMPLETE } from 'react-toolbox/lib/identifiers';
import { themr } from 'react-css-themr';
import SelectableItem from './SelectableItem';

import { autocompleteOverflowFactory } from './AutocompleteOverflow';
import { autocompleteFactory } from 'react-toolbox/lib/autocomplete/Autocomplete';
import TeamSelector from './TeamSelector';

import Chip from 'react-toolbox/lib/chip';
import Input from 'common/components/core/input/Input';
import theme from 'react-toolbox/lib/autocomplete/theme.scss';
import MultiSelectTheme from './MultiSelect.scss';
import autocompleteTheme from './Autocomplete.scss';

const AutocompleteOverflow = autocompleteOverflowFactory({
    Input,
    SelectableItem
});
const ThemedAutocompleteOverflow = themr(
    'AutocompleteOverflow',
    theme
)(AutocompleteOverflow);
const MultiSelectAutocomplete = themr(
    'AutocompleteOverflow',
    MultiSelectTheme
)(ThemedAutocompleteOverflow);

const ThemedInput = themr('Input', autocompleteTheme, {
    withRef: true
})(Input);
const Autocomplete = autocompleteFactory(Chip, ThemedInput);
const ThemedAutocomplete = themr(AUTOCOMPLETE, theme)(Autocomplete);
const CustomThemedAutocomplete = themr(
    AUTOCOMPLETE,
    autocompleteTheme
)(ThemedAutocomplete);

export default CustomThemedAutocomplete;
export {
    TeamSelector,
    MultiSelectAutocomplete as AutocompleteOverflow,
    ThemedAutocomplete as Autocomplete
};
